<template>
  <div>
    <quill-editor @change="onEditorBlur($event)" ref="quill" v-model="qcontent" :options="editorOption" />
    <input ref="upload" type="file" @change="change" class="quill-image-input" accept="image/jpeg, image/png"
      style="display: none" />
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { Quill, quillEditor } from "vue-quill-editor";
import { container, ImageExtend, QuillWatch } from "quill-image-extend-module";
Quill.register("modules/ImageExtend", ImageExtend);
// import QuillHtmlSourceButton from "quill-source-code-button";
// Quill.register("modules/htmlSource", QuillHtmlSourceButton);
export default {
  name: "quill",
  props: ["content", "placeholder"],
  components: { quillEditor },
  data() {
    return {
      editorOption: {
        placeholder: this.placeholder,
        modules: {
          // htmlSource: {},
          ImageExtend: {
            loading: true,
            name: "file",
            size: 2,
            action: process.env.BASE_API + "/api/upload/image",
            response: (res) => {
              console.log(res);
              if (res.code === 0 && res.data) {
                return res.data;
              } else {
                return "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNjAiIGhlaWdodD0iODAiPjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxNjAiIGhlaWdodD0iODAiIGZpbGw9IiNEREREREQiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgc3R5bGU9ImRvbWluYW50LWJhc2VsaW5lOm1pZGRsZTt0ZXh0LWFuY2hvcjptaWRkbGU7Zm9udC1zaXplOjQwcHgiIGZpbGw9IiNmMDAiPuS4iuS8oOWksei0pTwvdGV4dD48L3N2Zz4=";
              }
            },
            headers: (xhr) => {
              xhr.setRequestHeader(
                "Authorization",
                `Bearer ${localStorage.getItem("lidi.token")}`
              );
            },
            sizeError: () => {
              this.$dialog.alert({ title: "提示", message: "图片不能超过2M" });
            }, // 图片超过大小的回调
            start() {
              // console.log(this);
            }, // 可选参数 自定义开始上传触发事件
            end: () => { }, // 可选参数 自定义上传结束触发的事件，无论成功或者失败
            error: () => { }, // 可选参数 上传失败触发的事件
            success: () => { }, // 可选参数  上传成功触发的事件
            change: (xhr, formData) => { },
          },
          toolbar: {
            container: container,
            handlers: {
              image: function (value) {
                QuillWatch.emit(this.quill.id);
              },
            },
            theme: "snow",
          },
        },
      },
      qcontent: "",
    };
  },
  watch: {
    content(newContent, oldContent) {
      this.qcontent = newContent;
    },
  },
  methods: {
    setcontent(data) {
      this.qcontent = data;
    },
    change(e) {
      let file = e.target.files[0];
      // console.log(file);
      if (!file) return;
      this.$refs.upload.value = "";
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG && !isPNG) {
        return this.showwarntext("上传的图片只能是 JPG 和 PNG 格式!");
      } else if (!isLt2M) {
        return this.showwarntext("上传的图片最大不能超过2MB!");
      }
      let formData = new FormData();
      formData.set("file", file);
      this.$toast.loading({ message: "上传中..." });
      this.$api.upload(formData).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          if (res.data) {
            let quill = this.$refs.quill.quill;
            let length = quill.getSelection().index ? quill.getSelection().index : quill.selection.savedRange.index;
            quill.insertEmbed(length, "image", res.data);
            quill.setSelection(length + 1);
          } else {
            this.showwarntext("上传失败");
          }
        } else {
          this.showwarntext(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
        this.showwarntext("上传失败");
      });
    },
    showwarntext(text) {
      this.$alert(text);
    },
    onEditorBlur(e) {
      this.$emit("send", this.qcontent);
    },
  },
  created() {
    this.qcontent = this.content;
  },
  activated() { },
};
</script>
<style scoped>
.quill-editor {
  height: 300px;
  margin-bottom: 90px;
}
</style>
